// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__AF_3G","headerContent":"Header_headerContent__VSKiG","TDDh":"Header_TDDh__iGPHj","nav":"Header_nav__LVYU2","TDDl":"Header_TDDl__25x4k"};